import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '../BlogStyles';
import image from './image.png';

const ForSchools = ({ classes }) => (
  <div className={classes.container}>
    <img src={image} className={classes.image} alt="" />
    <b>Ashley Jones | 25 October 2022 | 3 mins</b>

    <p>
      The COVID-19 pandemic disrupted life for billions of children across the
      globe. The abrupt, unplanned switch from in-person education to distance
      learning had a tremendous impact on student progress. School districts
      scrambled to acquire the tools and knowledge needed to provide quality
      instruction in a digital format.&nbsp;
    </p>
    <p>
      While educators&rsquo; efforts were in good faith, students still
      struggled during this period, and understandably so. As a result of school
      closures, students lost an equivalent of one-third of a school
      year&rsquo;s worth of education on average, according to the{' '}
      <a href="https://www.nature.com/articles/s41562-022-01506-4">
        Nature Human Behavior
      </a>{' '}
      journal. To combat this academic loss, the{' '}
      <a href="https://www.whitehouse.gov/briefing-room/statements-releases/2022/07/05/fact-sheet-biden-harris-administration-launches-national-effort-to-support-student-success/">
        Biden administration
      </a>{' '}
      has urged schools to spend more money on tutoring. Tutoring can take many
      different forms, but&nbsp;within the scope of options, high-dosage
      tutoring is one of the best ways to combat learning loss.&nbsp;
    </p>
    <p>
      High-dosage tutoring typically takes place at least 3 times a week,
      lasting at least 30 minutes per session. Sessions are conducted in a small
      group or one-to-one setting to maximize impact. High-dosage tutoring
      initiatives have already led to success. In a study in the{' '}
      <a href="https://www.nber.org/system/files/working_papers/w28531/w28531.pdf">
        National Bureau of Economic Research
      </a>, researchers found that high-dosage tutoring can double or triple the
      amount of math learned by high school students each year. In the same
      study, researchers found the method to be as impactful as early education
      programs.&nbsp;
    </p>
    <p>
      Utilizing high-dosage tutoring can help combat the learning loss
      afflicting so many students. Reversing the effects of the pandemic&rsquo;s
      strain on students is a paramount priority for schools, and high-dosage
      tutoring is a proven and powerful solution. In addition, it is a
      cost-effective instruction method, when implemented properly. Consider the
      graphic below from a report by{' '}
      <a href="https://edtrust.org/wp-content/uploads/2021/03/Targeted-Intensive-Tutoring-as-a-Strategy-to-Solve-Unfinished-Learning-March-2021.pdf">
        Edtrust
      </a>, which details the best ways to utilize high-dosage tutoring:&nbsp;
    </p>
    <p>
      Everyone was impacted by the pandemic; loved ones were lost, financial
      hardships were created, and lifestyles were changed. Students lost their
      forward momentum and many fell far behind. High-dosage tutoring is an
      effective way to get students back on track and ready to succeed.
    </p>
    <p>
      Try Tutorfly for high-dosage tutoring by emailing us at info@tutorfly.org
      or giving us a call at 424-653-6159!
    </p>
  </div>
);

ForSchools.propTypes = {
  classes: PropTypes.object.isRequired, // eslint-disable-line
};

export default withStyles(ForSchools);
